import { Card, Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import { useMemo } from "react";
import { numberToCurrency } from "std/format";
import type { TApiRelatoriReferencia } from ".";

const { Title } = Typography;

type TTableBonificacao = {
	client1: string;
	mesRef1: string;
	valor1: string;
	client2: string | undefined;
	mesRef2: string | undefined;
	valor2: string | undefined;
};

const columns: ColumnType<TTableBonificacao>[] = [
	{
		dataIndex: "client1",
		key: "client1",
		title: "Cliente",
	},
	{
		dataIndex: "mesRef1",
		key: "mesRef1",
		title: "Mês referência",
	},
	{
		dataIndex: "valor1",
		key: "valor1",
		title: "Valor",
		render: (value) => numberToCurrency(value || 0),
	},
	{
		dataIndex: "client2",
		key: "client2",
		title: "Cliente",
	},
	{
		dataIndex: "mesRef2",
		key: "mesRef2",
		title: "Mês referência",
	},
	{
		dataIndex: "valor2",
		key: "valor2",
		title: "Valor",
		render: (value) => numberToCurrency(value || 0),
	},
];

export function TableRelReferencia({ data, title }: { data: TApiRelatoriReferencia | undefined; title: string }) {
	const precoLeites = data?.precoLeites || [];
	const bonificacoes = data?.bonificacoes || [];

	const formattedBonificacoes = useMemo(() => {
		const metade = Math.ceil(bonificacoes.length / 2);
		const primeiraMetade = bonificacoes.slice(0, metade);
		const segundaMetade = bonificacoes.slice(metade);
		const resultado = primeiraMetade.map((item, idx) => {
			const item2 = segundaMetade[idx];
			return {
				client1: `${item?.produtor?.for_codigoindividual} - ${item?.produtor?.pessoa?.pes_nome_razaosocial || ""}`,
				mesRef1: item?.bon_mes_ano,
				valor1: item?.bon_valor,
				client2: `${item2?.produtor?.for_codigoindividual} - ${item2?.produtor?.pessoa?.pes_nome_razaosocial || ""}`,
				mesRef2: item2?.bon_mes_ano,
				valor2: item2?.bon_valor,
			};
		});
		return resultado;
	}, [bonificacoes]);

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
				{precoLeites &&
					precoLeites.length > 0 &&
					precoLeites.map((pl) => {
						return (
							<Card key={pl.prl_idpk}>
								<h4>Rota: {pl?.rota?.rot_identificacao || ""} </h4>
								<h4>Transportador: {pl?.rota?.transportador?.pessoa?.pes_nome_razaosocial || ""}</h4>

								{/* Divide pl.itens em duas colunas */}
								{pl?.itens && pl?.itens.length > 0 && (
									<Flex gap={16} style={{ width: "100%" }}>
										{/* Primeira coluna */}
										<Flex vertical={true} style={{ flex: 1 }}>
											{pl.itens.slice(0, Math.ceil(pl.itens.length / 2)).map((item) => (
												<div key={item.prli_idpk}>
													{item?.prli_de} ATÉ {item?.prli_ate} {numberToCurrency(item?.prli_preco)}
												</div>
											))}
										</Flex>
										{/* Segunda coluna */}
										<Flex vertical={true} style={{ flex: 1 }}>
											{pl.itens.slice(Math.ceil(pl.itens.length / 2)).map((item) => (
												<div key={item.prli_idpk}>
													{item?.prli_de} ATÉ {item?.prli_ate} {numberToCurrency(item?.prli_preco)}
												</div>
											))}
										</Flex>
									</Flex>
								)}
							</Card>
						);
					})}

				<div>
					<Title level={4} style={{ margin: "0px" }}>
						Bonificações Temporárias
					</Title>

					<Table columns={columns} dataSource={formattedBonificacoes} pagination={false} size="small" rowClassName="zebra" />
				</div>
			</Flex>
		</ImpressaoContainer>
	);
}
